import type { MetricInfo } from '@az3fr/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const metricAdapter = createEntityAdapter<MetricInfo>();

const metricSlice = createSlice({
	name: 'entities/metric',
	initialState: metricAdapter.getInitialState(),
	reducers: {
		setAll: metricAdapter.setAll,
	},
});
type MetricSliceState = ReturnType<typeof metricAdapter.getInitialState>;

const metricSliceActions = { ...metricSlice.actions };
const metricSliceReducer = metricSlice.reducer;

export { metricSliceActions, metricSliceReducer, metricAdapter };
export type { MetricSliceState };
